import React, { useContext } from 'react';
import { PageAbsolutePath } from '../../../consts/Common';
import ReloadHandler from '../../common/ReloadHandler';
import SaveForLaterManager from './SaveForLaterManager';
import InsuranceNavStepper from './InsuranceNavStepper';
import { useCurrentPath } from '../useCurrentPath';
import { useOutletContext } from 'react-router-dom';
import { InsuranceJourneyContext } from '../../common/CommonTypes';
import NeedHelpPage from './NeedHelpPage';
import { SiteContext } from '../../../context/SiteContext';
import { CommonValidation } from '../../common/CommonValidation/commonValidation';

type QuestionnaireProps = {
  showNavStepper?: boolean;
  children: React.ReactNode;
};

const Questionnaire = ({
  children,
  showNavStepper = true
}: QuestionnaireProps): JSX.Element => {
  const currentPath = useCurrentPath();
  const { journey } = useOutletContext<InsuranceJourneyContext>();
  const { insuranceNavigationStatus } = journey;
  const { site } = useContext(SiteContext);

  const getReloadPage = (): string => {
    if (!site.user.isDealer) {
      return PageAbsolutePath.Insurance.Landing;
    }

    const dealerLoggedIn = CommonValidation.isNotEmpty(
      site.user.insuranceDealerName
    );

    if (dealerLoggedIn) {
      return PageAbsolutePath.Insurance.DealersHomePage;
    }

    return PageAbsolutePath.Insurance.DealerLandingPage;
  };

  return (
    <div>
      <div className='flex-row main-content questionnaire'>
        <div className='flex-column left-column'>
          <NeedHelpPage
            showCallMeBackButton={!site.user.isDealer}
            showCallYouBackHeading={!site.user.isDealer}
          />
        </div>
        <div className='flex-column right-column'>
          {showNavStepper && (
            <InsuranceNavStepper
              insuranceNavigationStatus={insuranceNavigationStatus}
              currentPath={currentPath}
            />
          )}

          {children}
        </div>
      </div>

      <SaveForLaterManager />
      <ReloadHandler reloadPath={getReloadPage()} />
    </div>
  );
};

export default Questionnaire;
